import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
import "./selectArticles.css";

const Article = (props) => {
  function handle() {
  }
  useEffect(() => {}, []);
  function formatTitle(x) {
    let words = x.split(" ");
    let firstLine = "";
    let secondLine = "";
    let lastWord = 0;
    for (var i = 0; i < words.length; i++) {
      let temp = firstLine + " " + words[i];
      if (temp.length > 29) {
        lastWord = i - 1;
        break;
      }
      firstLine = temp;
    }
    //lastWord = -1;
    let temp = lastWord;
    for (var i = lastWord + 1; i < words.length; i++) {
      let temp = secondLine + " " + words[i];
      if (temp.length > 18) {
        lastWord = i - 1;
        break;
      }
      secondLine = temp;
    }

    let all = firstLine + "\n" + secondLine;

    if (all.length < 60 && temp != lastWord) return all + "...";
    if (all.length < 60) return all;
    else return all.substring(0, 60).toUpperCase() + "...";
  }

  function formatBody(body) {
    if (body.length < 60) return body;
    else return body.substring(0, 60) + "...";
  }

  return (
    <>
      <div className="Vimg" style={{ maxWidth: "250px" }}>
        <img
          className="articleImg"
          src={
            props.article.template && props.article.template.imageUrl
              ? props.article.template.imageUrl
              : "https://d3i4lqsaxjar6n.cloudfront.net/post_images/61958e4b490a7c0003244ab4/large.jpg"
          }
          //  src='//d3i4lqsaxjar6n.cloudfront.net/post_images/61958e4b490a7c0003244ab4/large.jpg'
        />

        <div>
          <h2 className="VsubTitle" style={{ marginLeft: "7px" }}>
            {(props.article.name)}
          </h2>
          <p style={{ textAlign: "left", marginLeft: "7px", color: "rgb(200, 200, 190)" }}>
            {""}
          </p>
          <div>
            <p className="Vpara">{formatBody(props.article.description?props.article.description:"")}</p>
          </div>
          <label class="Vlabel">
            <input
              onChange={() => {
                props.handleSelect(props.ind);
              }}
              type="checkbox"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </>
  );
};

export default Article;
